import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "title", "content"]

  show(event) {
    event.preventDefault()
    
    // Get the link that was clicked
    const link = event.currentTarget
    
    // Update title if provided in data attribute
    const title = link.dataset.intentModalTitle
    if (title) {
      this.titleTarget.textContent = title
    } else {
      this.titleTarget.textContent = "Add Intent"
    }
    
    // Update the turbo frame src if we have an href (for edit links)
    if (link.href) {
      const turboFrame = this.contentTarget.querySelector('turbo-frame')
      if (turboFrame) {
        turboFrame.src = link.href
        turboFrame.reload()
      }
    }
    
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  hide(event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
  }
}